var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isOpen)?_c('modal',{attrs:{"class-name":"widget-modal"},on:{"close":function($event){return _vm.$emit('close')}},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('div',[_c('Configurator')],1)]},proxy:true}],null,false,801695500)}):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-033ca51f","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/WidgetModal.vue
// module id = null
// module chunks = 